<div class="white-box main-black mt-4 p-4 border-radius">
	<div class="col-sm-6 col-md-6">
		<h4 class="mb-2">{{config.title}} <app-help-tooltip *ngIf="tooltipText || [deviceTypes[0]]" [field]="tooltipText || deviceTypesTooltips[deviceTypes[0]]"></app-help-tooltip></h4>
	</div>

	<!-- filters -->
	<div class="d-flex flex-wrap gap-3 mb-4 align-items-end">
		<!-- time filter -->
		<ng-container *ngIf="!useParentFilters">
		<div class="col-xl-3 col-md-3">
			<div class="input-group">
				<div class="input-group-prepend">
					<span class="input-group-text">{{'g.start_date' | translate}}</span>
				</div>
				<input type="text" [ngClass]="{'invalid-input': invalidTruckUsageDate}" class="form-control" placeholder="mm/dd/yyyy" name="dp1" (ngModelChange)="changeDate('powerUsageFromDate', $event)" [(ngModel)]="powerUsageFromDate" bsDatepicker #d1="bsDatepicker" [bsConfig]="{containerClass: 'theme-dark-blue'}" [minDate]="powerUsageMinDate" [maxDate]="powerUsageToDate">
				<div class="input-group-append pointer" (click)="d1.toggle()">
					<span class="input-group-text"><i class="fa fa-calendar"></i></span>
				</div>
			</div>
		</div>

		<div class="col-xl-3 col-md-3">
			<div class="input-group">
				<div class="input-group-prepend">
					<span class="input-group-text">{{'g.end_date' | translate}}</span>
				</div>
				<input type="text" [ngClass]="{'invalid-input': invalidTruckUsageDate}" class="form-control" placeholder="mm/dd/yyyy" name="dp2" (ngModelChange)="changeDate('powerUsageToDate', $event)" [(ngModel)]="powerUsageToDate" bsDatepicker #d2="bsDatepicker" [bsConfig]="{containerClass: 'theme-dark-blue'}" [minDate]="powerUsageFromDate" [maxDate]="yesterday">
				<div class="input-group-append pointer" (click)="d2.toggle()">
					<span class="input-group-text"><i class="fa fa-calendar"></i></span>
				</div>
			</div>
		</div>
		</ng-container>

		<!-- truck type filter -->
		<div class="col-xl-3 col-md-3" *ngIf="hasTruckTypesFilter">
			<ng-select class="select full-width"
				[searchable]="false"
				[clearable]="false"
				[items]="truckTypeList"
				bindLabel="label"
				bindValue="value"
				[placeholder]="'devices.truck_type' | translate"
				[(ngModel)]="selectedDailyUsageTruckTypeFilter"
				(change)="getDailyRtData()"
			>
			</ng-select>
		</div>

		<!-- export and print -->
		<div class="col-1 d-inline-flex ml-auto" *ngIf="(powerUsage.amp && powerUsage.amp.length > 0) || (powerUsage.kw && powerUsage.kw.length > 0)">
			<button class="btn fa fa-print fa-lg ml-1" printTitle="{{'g.performance' | translate}}" [useExistingCss]="true" printSectionId="usage-chart" ngxPrint title="{{'g.print' | translate}}"></button>
			<button class="fa fa-upload btn" title="{{'g.export_to_csv' | translate}}" (click)="exportUsage()"></button>
		</div>
	</div>

	<div id="usage-chart" *ngIf="powerUsage.amp && (powerUsage.amp.length > 0 || powerUsage.kw.length > 0); else noDataToShow">
		<app-print-filters [title]="config.title" [filters]="printFilters"></app-print-filters>
		<!-- charts -->
		<sct-charts
			*ngIf="powerUsage.amp && powerUsage.amp.length > 0"
			id="truck_amp"
			[title]="config.ampChartTitle"
			[data]="powerUsage.amp"
			[columnNames]="powerUsage.ampColumns"
			[options]="powerUsage.ampConfig"
			[haveZoom]="true"
			[type]="'LineChart'"
			[height]="500"
		></sct-charts>
		<sct-charts
			*ngIf="powerUsage.kw && powerUsage.kw.length > 0"
			id="truck_kw"
			[title]="config.kwChartTitle"
			[data]="powerUsage.kw"
			[columnNames]="powerUsage.kwColumns"
			[options]="powerUsage.kwConfig"
			[haveZoom]="true"
			[type]="'LineChart'"
			[height]="500"
		></sct-charts>
	</div>
</div>

<ng-template #noDataToShow class="mt-4">
	<div class="alert alert-info">{{'g.no_data_to_show' | translate}}</div>
</ng-template>
